import React, { useContext, useEffect, useState } from "react";
import { PartnerContext } from "../PartnerOutlet";
import AxiosInstance from "../../../../AxiosInstance";
import { useNavigate, useParams } from "react-router-dom";
import { amountFormat } from "../../../../utils";
import { Table, Tabs } from "antd";
import moment from "moment";
import InvestmentChart from "../../InvestorDashboard/investmentChart";
import { useMediaQuery } from "react-responsive";

export default function PartnerInvestorByIdView() {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1000px)" });
  const navigate = useNavigate();
  let status = "DONE";
  let isMatured = false;
  const [summaryVisible, setSummaryVisible] = useState(true);
  const partnerContext = useContext(PartnerContext);
  const [loading, setLoading] = useState(true);
  const [paginationMetaData, setPaginationMetaData] = useState({});
  var [dataSource, setDataSource] = useState([]);
  const [summaryData, setSummaryData] = useState({});
  let { investorId } = useParams();

  useEffect(() => {
    let ignore = false;

    if (!ignore) {
      if (partnerContext.viewMode !== "INVESTOR") {
        navigate("/partnerDashboard");
      }
      getTableData(0, status, isMatured);
      getInvestorSummaryData(false);
      console.log(investorId);
      //   getSummaryData();
    }
    return () => {
      ignore = true;
    };
  }, []);
  const columns = [
    {
      title: "Policy Number",
      dataIndex: "policyNumber",
      key: "policyNumber",
      align: "center",
      //   render: (text, policy) => policy["firstName"] + " " + policy["lastName"],
    },
    {
      title: "Total Inv. Amount",
      dataIndex: "totalInvestmentAmount",
      key: "totalInvestmentAmount",
      align: "right",
      render: (text, policy) => {
        const investmentAmount = policy?.investmentAmount;
        return <>{investmentAmount ? amountFormat(investmentAmount) : "N/A"}</>;
      },
    },
    {
      title: "Current Value",
      dataIndex: "currentSurrenderValue",
      key: "currentSurrenderValue",
      align: "right",
      render: (text, policy) => <>{text ? amountFormat(text) : "N/A"}</>,
    },
    {
      title: "Growth",
      dataIndex: "growthRatio",
      key: "growthRatio",
      align: "center",
      render: (text, policy) =>
        text ? parseFloat(text).toFixed(1) + " %" : "N/A",
    },
    {
      align: "center",
      title: "Liquidation Date",
      dataIndex: "liquidationDate",
      render: (text, policy) =>
        text ? moment(text).format("DD/MM/YYYY") : "N/A",
    },
  ];
  const inProgressTabColumns = [
    {
      title: "Policy Number",
      dataIndex: "policyNumber",
      key: "policyNumber",
      align: "center",
      //   render: (text, policy) => policy["firstName"] + " " + policy["lastName"],
    },
    {
      title: "Total Inv. Amount",
      dataIndex: "totalInvestmentAmount",
      key: "totalInvestmentAmount",
      align: "right",
      render: (text, policy) => {
        const investmentAmount = policy?.investmentAmount;
        return <>{investmentAmount ? amountFormat(investmentAmount) : "N/A"}</>;
      },
    },
    {
      title: "Current Value",
      dataIndex: "currentSurrenderValue",
      key: "currentSurrenderValue",
      align: "right",
      render: (text, policy) => <>{text ? amountFormat(text) : "N/A"}</>,
    },
    {
      title: "Growth",
      dataIndex: "growthRatio",
      key: "growthRatio",
      align: "center",
      render: (text, policy) =>
        text ? parseFloat(text).toFixed(1) + " %" : "N/A",
    },
    {
      align: "center",
      title: "Current Status",
      dataIndex: "assignmentStatus",
    },
  ];
  const getTableData = async (skip, status, isMatured) => {
    setLoading(true);
    const url = `/investor/policyList?take=10&skip=${skip}&investorId=${investorId}&status=${status}&isMatured=${isMatured}`;
    AxiosInstance()
      .get(url)
      .then((resp) => {
        let { data } = resp;
        // setPolicies(data.data);
        setDataSource(data.data);
        setPaginationMetaData(data.paginationMetaData);
      })
      .catch((err) => {})
      .finally(() => {
        setLoading(false);
      });
  };
  const getInvestorSummaryData = async (isMatured) => {
    setLoading(true);
    const url = `/investor/summary?investorId=${investorId}&isMatured=${isMatured}`;
    AxiosInstance()
      .get(url)
      .then((resp) => {
        let { data } = resp;
        // setPolicies(data.data);
        setSummaryData(data);
      })
      .catch((err) => {});
  };

  const change = (data) => {
    getTableData((data - 1) * 10, status, isMatured);
  };

  var SummaryComponent = () => {
    return (
      <>
        <div className="in-summary grid-container-in-summary">
          <div>
            <div className="heading-in">Investments</div>
          </div>
          <div>
            <div className="key">Total Investment</div>
            <div className="value">
              {summaryData?.totalInvestmentValue
                ? amountFormat(summaryData.totalInvestmentValue)
                : "-"}
            </div>
            <div className="key mt-3">Total Fund Value</div>
            <div className="value">
              {summaryData?.totalSurrenderValue
                ? amountFormat(summaryData.totalSurrenderValue)
                : "-"}
            </div>
          </div>

          <div className="">
            <div className="key">Liquidation Value (Tentative)</div>
            <div className="value">
              {summaryData?.liquidationAmount
                ? amountFormat(summaryData.liquidationAmount)
                : "-"}
            </div>
            <div className="key mt-3">Unrealized P&L</div>
            <div className="value">
              {summaryData?.totalUnrealizedPAndL
                ? amountFormat(summaryData.totalUnrealizedPAndL)
                : "-"}
            </div>
            {/* <div className="key mt-3">Tentative Maturity Value</div>
            <div className="value">
              {summaryData.tentativeMaturityValue
                ? amountFormat(summaryData.tentativeMaturityValue)
                : "-"}
            </div> */}
          </div>

          <div className="">
            <InvestmentChart summaryData={summaryData}></InvestmentChart>

            <div className="d-flex justify-content-center">
              Growth{" "}
              {summaryData?.growthRatio ? summaryData.growthRatio + " %" : "-"}
            </div>
          </div>
        </div>
      </>
    );
  };
  var SummaryComponentMobile = () => {
    return (
      <>
        <div className="in-summary grid-container-in-summary">
          <div>
            <div className="heading-in">Investments</div>
          </div>
          <div>
            <div className="key">Total Investment</div>
            <div className="value">
              {summaryData?.totalInvestmentValue
                ? amountFormat(summaryData.totalInvestmentValue)
                : "-"}
            </div>
            <div className="key">Total Fund Value</div>
            <div className="value">
              {summaryData?.totalSurrenderValue
                ? amountFormat(summaryData.totalSurrenderValue)
                : "-"}
            </div>
          </div>

          <div className="">
            <div className="key">Liquidation Value (Tentative)</div>
            <div className="value">
              {summaryData?.liquidationAmount
                ? amountFormat(summaryData.liquidationAmount)
                : "-"}
            </div>
            <div className="key">Tentative Maturity Value</div>
            <div className="value">
              {summaryData?.tentativeMaturityValue
                ? amountFormat(summaryData.tentativeMaturityValue)
                : "-"}
            </div>
          </div>

          {/* <div className="">
            <InvestmentChart  summaryData={summaryData}></InvestmentChart>

            <div className="d-flex justify-content-center">
              Growth{" "}
              {summaryData.growthRatio ? summaryData.growthRatio + " %" : "-"}
            </div>
          </div> */}
        </div>
      </>
    );
  };
  const items = [
    {
      key: "1",
      label: "Active Policy",
      children: (
        <Table
          bordered={true}
          scroll={{ x: 400 }}
          loading={loading}
          className="table"
          dataSource={[...dataSource]}
          columns={columns}
          pagination={{
            pageSize: 10,
            total: paginationMetaData.count,
            onChange: change,
          }}
        />
      ),
    },
    {
      key: "2",
      label: "In Progress Policy",
      children: (
        <Table
          bordered={true}
          scroll={{ x: 400 }}
          loading={loading}
          className="table"
          dataSource={[...dataSource]}
          columns={inProgressTabColumns}
          pagination={{
            pageSize: 10,
            total: paginationMetaData.count,
            onChange: change,
          }}
        />
      ),
    },
    {
      key: "3",
      label: "Matured Policy",
      children: (
        <Table
          bordered={true}
          scroll={{ x: 400 }}
          loading={loading}
          className="table"
          dataSource={[...dataSource]}
          columns={columns}
          pagination={{
            pageSize: 10,
            total: paginationMetaData.count,
            onChange: change,
          }}
        />
      ),
    },
  ];
  const onChange = (key) => {
    switch (key) {
      case "1":
        status = "DONE";
        isMatured = false;
        getInvestorSummaryData(false);

        setSummaryVisible(true);
        break;

      case "2":
        status = "PENDING,SENT,REJECTED,PAYMENT_PENDING,PAYMENT_DONE";
        setSummaryData({});
        isMatured = false;
        break;

      case "3":
        status = "DONE";
        isMatured = true;
        getInvestorSummaryData(true);

        setSummaryVisible(true);

        break;
      default:
        break;
    }
    getTableData(0, status, isMatured);
  };

  return (
    <>
      <div className="container">
        <div className="  d-flex justify-content-center ">
          {Object.keys(summaryData).length > 0 && (
            <>
              {" "}
              {isTabletOrMobile ? (
                <SummaryComponentMobile />
              ) : (
                <SummaryComponent />
              )}
            </>
          )}
        </div>
      </div>

      <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
    </>
  );
}
